import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SubWebsocketMessageRequest } from '@qtek/core/websockets-core';
import { Tag } from '@qtek/shared/models';

export const TagManagerActions = createActionGroup({
  source: 'Tag Manager',
  events: {
    'Connect Tags': props<{
      payload?: Partial<Omit<SubWebsocketMessageRequest, 'ent' | 'op'>>;
    }>(),
    'Disconnect Tags': emptyProps(),
    'Query Tags Success': props<{ tags: Tag[] }>(),
    'Query Tags Failure': props<{ error: Error }>(),
    'Create Tag': props<{
      tag: Pick<Tag, 'name' | 'desc' | 'color' | 'icon'>;
    }>(),
    'Create Tag Success': props<{ tag: Tag }>(),
    'Create Tag Failure': props<{ error: Error }>(),
    'Update Tag': props<{
      tag: Pick<Tag, 'name' | 'desc' | 'color' | 'icon' | '_id'>;
    }>(),
    'Update Tag Success': props<{ tag: Tag }>(),
    'Update Tag Failure': props<{ error: Error }>(),
    'Delete Tag': props<{ tag: Pick<Tag, '_id'> }>(),
    'Delete Tag Success': props<{ tag: Tag }>(),
    'Delete Tag Failure': props<{ error: Error }>(),
  },
});
